"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFieldType = exports.mapPropositionsToResults = exports.isPromotionType = void 0;
var _mergeInputField = require("./mergeInputField.data");
var lookupType = _mergeInputField.dataTypes.lookupType,
  lookupFieldType = _mergeInputField.dataTypes.lookupFieldType,
  promotionFieldType = _mergeInputField.dataTypes.promotionFieldType;
var promotionType = _mergeInputField.dataTypes.promotionType;
var getFieldType = function getFieldType(sourceType) {
  return sourceType === lookupType ? lookupFieldType : promotionFieldType;
};
exports.getFieldType = getFieldType;
var isPromotionType = function isPromotionType(_ref) {
  var type = _ref.type;
  return type === promotionType;
};
exports.isPromotionType = isPromotionType;
var mapPropositionsToResults = function mapPropositionsToResults(_ref2) {
  var parentId = _ref2.id,
    parentTitle = _ref2.title,
    sourceType = _ref2.sourceType;
  return function (result) {
    return {
      title: result,
      sourceType: getFieldType(sourceType),
      parentId: parentId,
      parentTitle: parentTitle
    };
  };
};
exports.mapPropositionsToResults = mapPropositionsToResults;